define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'scroll'],
    function($, transit, modernizr, container, preloader, scroll)
    {

        return (function() {

            const name = 'layout';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {
            };

            model.privateVars = {
            };

            model.methods = {

            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                canNavigateAction: 0,

                menu: {
                    headerMenuOpened: false,
                    headerMenuAnim: false
                }
            };

            view.startup = function() {

                $(view.publicVars.cssId.pageCls + ' iframe').each(function () {
                    this.src = this.src;
                });

                preloader.setPreloadBulk(name, view.publicVars.preloadImgTab);

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFooterAnimMainId, 'animate__fadeIn', 'layout', {});
            };

            view.bind = function() {
                $(view.publicVars.cssId.menu.headerMenuCls).click(function () {

                    const width = $(window).width();

                    if(width < 768) {
                        if (!view.privateVars.menu.headerMenuAnim) {
                            view.privateVars.menu.headerMenuAnim = true;
                            view.methods.menu.handleMenu();
                        }
                    }
                });

                $(document).click(function (e) {
                    var container = $(view.publicVars.cssId.menu.headerMenuCls);
                    const width = $(window).width();

                    if (!container.is(e.target) // if the target of the click isn't the container...
                        && width < 768
                        && container.has(e.target).length === 0
                        && view.privateVars.menu.headerMenuOpened) // ... nor a descendant of the container
                    {
                        view.methods.menu.handleMenuClose();
                    }
                });
            };

            view.methods = {
                menu: {
                    handleMenu: () => {
                        if (!view.privateVars.menu.headerMenuOpened) {
                            view.methods.menu.handleMenuOpen();
                        } else {
                            view.methods.menu.handleMenuClose();
                        }
                    },

                    handleMenuOpen: () => {
                        view.privateVars.menu.headerMenuOpened = true;

                        $(view.publicVars.cssId.menu.headerMenuCls).addClass(view.publicVars.cssId.menu.isOpenedCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).css({transform: 'rotate(0deg)'});
                        $(view.publicVars.cssId.menu.headerMenuIconId).removeClass(view.publicVars.cssId.menu.canHoverCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).transit({rotate: '360deg'}, 300);

                        $(view.publicVars.cssId.menu.headerMenuInnerId).slideDown(300, () => {
                            $(view.publicVars.cssId.menu.headerMenuIconId).addClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                            view.privateVars.menu.headerMenuAnim = false;
                        });
                    },

                    handleMenuClose: () => {
                        view.privateVars.menu.headerMenuOpened = false;

                        $(view.publicVars.cssId.menu.headerMenuIconId).removeClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                        $(view.publicVars.cssId.menu.headerMenuCls).removeClass(view.publicVars.cssId.menu.isOpenedCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).transit({rotate: '0deg'}, 300);

                        $(view.publicVars.cssId.menu.headerMenuInnerId).slideUp(300, () => {
                            $(view.publicVars.cssId.menu.headerMenuIconId).addClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                            view.privateVars.menu.headerMenuAnim = false;
                            $(view.publicVars.cssId.menu.headerMenuInnerId).removeAttr('style');
                        });
                    },
                },

            };

            /* custom events */
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function(options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

    });